export default __webpack_public_path__ + "static/media/icon-flag-netherlands.47e03e2e.svg";